import React, { useState, useCallback } from 'react';
import { useField } from '@rocketseat/unform';
import { useSelector } from 'react-redux';
import { GoSearch } from 'react-icons/go';

import {
  Text,
  Button,
  Dropdown,
  TextField,
  ComboModalidadeTermo,
} from '@unimed-fesp/components';

import TipoPesquisaEnum from '../../../enums/TipoPesquisaBeneficiarioEnum';

// #region Import Componentes
import DatePicker from '../../molecules/DatePicker';
// #endregion

import theme from '../../../styles/theme';
import { InlineContainer, ContButton, LabelDate } from './styles';

function FormPesquisaBeneficiario({
  formParams,
  setFormParams,
  handlePesquisar,
  desabilitarBtnPesquisar = false,
  resetarPagination,
}) {
  const { response } = useSelector((state) => state.modalidade);
  const modalidades = response;

  const optionsTipoConsulta = [
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          tipoConsulta:
            TipoPesquisaEnum.returnPropName.ContratanteModalidadeTermo,
        }));
        resetarPagination();
      },
      text: TipoPesquisaEnum.returnFormatName.ContratanteModalidadeTermo,
    },
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          tipoConsulta:
            TipoPesquisaEnum.returnPropName.ContratanteCodigoUnimedCartao,
        }));
        resetarPagination();
      },
      text: TipoPesquisaEnum.returnFormatName.ContratanteCodigoUnimedCartao,
    },
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          tipoConsulta:
            TipoPesquisaEnum.returnPropName.ContratanteNomeTipoBeneficiario,
        }));
        resetarPagination();
      },
      text: TipoPesquisaEnum.returnFormatName.ContratanteNomeTipoBeneficiario,
    },
    {
      onClickOption: () => {
        setFormParams((oldValue) => ({
          ...oldValue,
          tipoConsulta:
            TipoPesquisaEnum.returnPropName.ContratanteNomeDataNascimento,
        }));
        resetarPagination();
      },
      text: TipoPesquisaEnum.returnFormatName.ContratanteNomeDataNascimento,
    },
  ];

  const shapeModalidades = useCallback(
    (modalidadesParam) =>
      modalidadesParam.map((modalidade) => ({
        text: modalidade.codigoModalidade.toString(),
        termos: modalidade.termos.map((termo) => termo.codigoTermo.toString()),
      })),
    []
  );

  function handleChangeInput(e) {
    const { name, value } = e.target;
    setFormParams((oldValue) => ({ ...oldValue, [name]: value }));
  }

  function handleChangeKeyValue(key, value) {
    if (!value) return;

    setFormParams((oldValue) => ({ ...oldValue, [key]: value }));
  }

  return (
    <InlineContainer>
      <Dropdown
        options={optionsTipoConsulta}
        tipo="dropdown"
        width={310}
        height={46}
        marginBottom={30}
        marginTop={9}
        padding-left={5}
        labelText="Tipo Consulta"
        name="tipoConsulta"
      >
        {
          TipoPesquisaEnum.returnFormatName[
            formParams?.tipoConsulta || 'ContratanteModalidadeTermo'
          ]
        }
      </Dropdown>
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteNomeDataNascimento && (
        // Contratante + Nome + Data Nascimento
        <TextField
          name="nomeBeneficiarioI"
          labelText="Nome Benef."
          width={200}
          height={47}
          marginBottom={30}
          marginTop={11}
          placeholder="Nome Beneficiario"
          font="13px 'Calibri Regular'"
          value={formParams?.nomeBeneficiarioI}
          onChange={(e) => handleChangeInput(e)}
        />
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteNomeDataNascimento && (
        // Contratante + Nome + Data Nascimento
        <LabelDate>
          <Text text="Data de nascimento" marginTop={6} />
          <DatePicker
            name="dataNascimento"
            value={formParams?.dataNascimento}
            onChange={(e) => handleChangeKeyValue('dataNascimento', e)}
          />
        </LabelDate>
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteCodigoUnimedCartao && (
        // Contratante + Código da Unimed + Cartao
        <TextField
          name="codDaUnimed"
          labelText="Cod. da Unimed"
          width={180}
          height={47}
          marginBottom={30}
          marginTop={11}
          placeholder="Cod. da Unimed"
          font="13px 'Calibri Regular'"
          value={formParams?.codDaUnimed}
          onChange={(e) => handleChangeInput(e)}
        />
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteCodigoUnimedCartao && (
        // Contratante + Código da Unimed + Cartao
        <TextField
          name="cartao"
          labelText="Cartão"
          width={200}
          height={47}
          marginBottom={30}
          marginTop={11}
          placeholder="Cartão"
          font="13px 'Calibri Regular'"
          value={formParams?.cartao}
          onChange={(e) => handleChangeInput(e)}
        />
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteNomeTipoBeneficiario && (
        // Contratante + Nome + Tipo Beneficiário
        <TextField
          name="nomeBenefTpBeneficiario"
          labelText="Nome Benef."
          width={200}
          height={47}
          marginBottom={30}
          marginTop={11}
          placeholder="Nome Benef.:"
          font="13px 'Calibri Regular'"
          value={formParams?.nomeBenefTpBeneficiario}
          onChange={(e) => handleChangeInput(e)}
        />
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteNomeTipoBeneficiario && (
        // Contratante + Nome + Tipo Beneficiário
        <Dropdown
          name="titular"
          labelText="Titular"
          width={200}
          height={47}
          marginBottom={30}
          marginTop={11}
          font="13px 'Calibri Regular'"
          disable
        >
          Titular
        </Dropdown>
      )}
      {formParams?.tipoConsulta ===
        TipoPesquisaEnum.returnPropName.ContratanteModalidadeTermo && (
        // Contratante + Modalidade + Termo
        <ComboModalidadeTermo
          modalidade={formParams?.modalidade || ''}
          setModalidade={(value) => handleChangeKeyValue('modalidade', value)}
          termo={formParams?.termo || ''}
          setTermo={(value) => handleChangeKeyValue('termo', value)}
          modalidades={shapeModalidades(modalidades)}
          margin={11}
        />
      )}

      <ContButton>
        <Button
          tipo="primary"
          paddingTop={10}
          justifyCenter
          alignCenter
          height={47}
          font="16px unimed_slabregular"
          type="submit"
          disabled={desabilitarBtnPesquisar}
          onClick={handlePesquisar}
        >
          <GoSearch
            color={theme.white}
            size={18}
            style={{ marginRight: '8px' }}
          />
          Pesquisar
        </Button>
      </ContButton>
    </InlineContainer>
  );
}

export default FormPesquisaBeneficiario;
